import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { WorkOrderType } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';
import { useEvidencePermission } from '@utils';
import { useColumns } from './work-order-type-columns';
import { Fields } from './work-order-type-fields';
import { useValidationSchema } from './work-order-type-schema';

export function WorkOrderTypes() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();
  const columns = useColumns();

  const btnPermissions = useEvidencePermission({
    options: {
      NEW: [Permission.WORK_ORDER_TYPE_WRITE],
      EDIT: [Permission.WORK_ORDER_TYPE_WRITE],
      REMOVE: [Permission.WORK_ORDER_TYPE_WRITE],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<WorkOrderType>({
    identifier: 'WORK_ORDER_TYPE',
    apiProps: {
      url: EvidenceApiUrl.WORK_ORDER_TYPES,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__WORK_ORDER_TYPE__TABLE__TITLE',
        defaultMessage: 'Druhy PP',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__WORK_ORDER_TYPE__DETAIL__TITLE',
          defaultMessage: 'Druh PP',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: btnPermissions,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
